<template>
  <v-form ref="form" v-model="validacion" lazy-validation>
    <v-layout>
      <v-flex>
        <v-text-field v-model="rut" v-if="tipoUsuarioValue == tipoUsuarioProveedor" label="RUT (12345678-K)"
          maxlength="11" :error-messages="rutErrors" :box="tipeView == 'crear' ? false : isDisabled || vistaconsulta"
          :readonly="tipeView == 'crear' ? false : isDisabled || vistaconsulta" @focusout="checkRUT"
          @input="$v.rut.$touch()" @blur="tipeView == 'crear' ? $v.rut.$touch() : null"></v-text-field>
        <v-text-field v-model="username" v-if="tipoUsuarioValue == tipoUsuarioProveedor"
          :error-messages="usernameErrors" label="E-mail" :box="tipeView == 'crear'
            ? false
            : isDisabled || disableonmodifica || vistaconsulta
            " :readonly="tipeView == 'crear'
              ? false
              : isDisabled || disableonmodifica || vistaconsulta
              " @input="$v.username.$touch()" @blur="tipeView == 'crear' ? $v.username.$touch() : null"></v-text-field>
        <v-text-field v-model="username" v-if="tipoUsuarioValue != tipoUsuarioProveedor"
          :error-messages="usernameErrors" label="E-mail" :box="tipeView == 'crear'
            ? false
            : isDisabled || disableonmodifica || vistaconsulta
            " :readonly="tipeView == 'crear'
              ? false
              : isDisabled || disableonmodifica || vistaconsulta
              " @focusout="checkUsername" @input="$v.username.$touch()"
          @blur="tipeView == 'crear' ? $v.username.$touch() : null"></v-text-field>
        <v-text-field v-model="rut" v-if="tipoUsuarioValue != tipoUsuarioProveedor" label="RUT (12345678-K)"
          maxlength="11" :error-messages="rutErrors" :box="tipeView == 'crear' ? false : isDisabled || vistaconsulta"
          :readonly="tipeView == 'crear' ? false : isDisabled || vistaconsulta" @input="$v.rut.$touch()"
          @blur="tipeView == 'crear' ? $v.rut.$touch() : null"></v-text-field>
        <v-text-field v-model="nombre" :error-messages="nombreErrors" label="Nombre"
          :box="tipeView == 'crear' ? false : isDisabled || vistaconsulta"
          :readonly="tipeView == 'crear' ? false : isDisabled || vistaconsulta" @input="$v.nombre.$touch()"
          @blur="tipeView == 'crear' ? $v.nombre.$touch() : null"></v-text-field>
        <v-text-field v-model="apellido" :error-messages="apellidoErrors" label="Apellido"
          :box="tipeView == 'crear' ? false : isDisabled || vistaconsulta"
          :readonly="tipeView == 'crear' ? false : isDisabled || vistaconsulta" @input="$v.apellido.$touch()"
          @blur="tipeView == 'crear' ? $v.apellido.$touch() : null"></v-text-field>
        <v-select v-model="tipoUsuarioValue" :items="tipoUsuarioSelect" item-text="name" item-value="code"
          :error-messages="tipoSelectErrors" label="Tipo usuario" :box="tipeView == 'crear'
            ? false
            : isDisabled || disableonmodifica || vistaconsulta
            " :readonly="tipeView == 'crear'
              ? false
              : isDisabled || disableonmodifica || vistaconsulta
              " @input="$v.tipoUsuarioValue.$touch()" @blur="tipeView == 'crear' ? $v.tipoUsuarioValue.$touch() : null"
          @change="loadRoles()"></v-select>
        <v-select v-model="rolUsuarioValue" :items="rolUsuarioSelect" item-text="nombre" item-value="id"
          :error-messages="rolSelectErrors" label="Rol" :box="(tipeView == 'crear' || tipeView == 'modifica')
            ? false
            : isDisabled || disableonmodifica || vistaconsulta
            " :readonly="(tipeView == 'crear' || tipeView == 'modifica')
              ? false
              : isDisabled || disableonmodifica || vistaconsulta
              " @input="$v.rolUsuarioValue.$touch()"
          @blur="tipeView == 'crear' ? $v.rolUsuarioValue.$touch() : null"></v-select>
      </v-flex>
      <v-flex xs12 md6></v-flex>
    </v-layout>
    <v-card-actions class="pb-3">
      <v-btn :loading="loading" v-if="tipeView == 'crear' || tipeView == 'modifica'" color="primary" class="mb-2"
        @click.prevent="save()">
        Guardar
        <v-icon right dark>save</v-icon>
      </v-btn>
    </v-card-actions>
  </v-form>
</template>
<script>
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";
import axios from "axios";
import { misRoles } from "@/mixins/roles.js";

export default {
  name: "usuario-data",
  components: {},
  mixins: [misRoles, validationMixin],
  props: {},
  data() {
    return {
      tipeView: "",
      username: "",
      validacion: false,
      rut: "",
      rutErrors: [],
      nombre: "",
      apellido: "",
      rolUsuarioValue: null,
      tipoUsuarioValue: null,
      tipoUsuarioSelect: [
        { name: "AGENCIA", code: 0 },
        { name: "PROVEEDOR", code: 1 },
      ],
      rolUsuarioSelect: [],
      resp: [],
      body: [],
      usuario: "",
      exist: false,
      contratoId: "",
      id: "",
      loading: false,
      tipoUsuarioProveedor: 1,
    };
  },
  validations: {
    apellido: { required },
    rut: { maxLength: maxLength(11) },
    nombre: { required },
    username: { required, email },
    tipoUsuarioValue: { required },
    rolUsuarioValue: { required },
  },

  created() {
    this.contratoId = this.$store.getters.contratoStored;
    console.log("params.tipeUser::" + this.$route.params.tipeUser);
    this.username = this.$route.params.username;
    this.id = this.$route.params.id;
    this.tipeView = this.$route.params.tipeView;
    if (!this.tipeView || this.tipeView == null || this.tipeView == "") {
      this.tipeView = "crear";
    }

    // Nuevo código para manejar preselección
    if (this.$route.params.tipeUser) {
      const tipo = this.tipoUsuarioSelect.find(
        item => item.name === this.$route.params.tipeUser
      );
      if (tipo) {
        this.tipoUsuarioValue = tipo.code;
        this.tipoUsuarioSelect = [tipo]; // Fijar solo la opción recibida
        this.loadRoles(); // Ejecutar carga inicial de roles
      }
    } else if (this.tipeView == "modifica") {
      // Mantener lógica original modificada
      const tipo = this.tipoUsuarioSelect.find(
        item => item.name === this.$route.params.tipeUser
      );
      if (tipo) {
        this.tipoUsuarioValue = tipo.code;
        this.loadRoles();
      }
    }

    if (this.tipeView == "crear") {
      // ... lógica original ...
    }
  },
  mounted() {
    if (this.tipeView == "consulta" || this.tipeView == "modifica") {
      this.loadData();
    } else if (this.tipeView == "crear") {
      this.loadRoldata();
    }
    // console.log("st::this.rolUsuarioSelect:" + JSON.stringify(this.rolUsuarioSelect, null, 2));
  },
  computed: {
    nombreErrors() {
      const errors = [];
      if (!this.$v.nombre.$dirty) return errors;
      !this.$v.nombre.required && errors.push("Nombre es obligatorio.");
      return errors;
    },
    apellidoErrors() {
      const errors = [];
      if (!this.$v.apellido.$dirty) return errors;

      !this.$v.apellido.required && errors.push("Apellido es obligatorio.");
      return errors;
    },
    usernameErrors() {
      const errors = [];
      if (!this.$v.username.$dirty) return errors;
      !this.$v.username.email &&
        errors.push("Debe ingresar un correo electronico valido.");
      !this.$v.username.required &&
        errors.push("Correo electronico es obligatorio.");
      if (this.tipoUsuarioValue != this.tipoUsuarioProveedor && this.exist) {
        errors.push("Usuario ya existe en el contrato");
      }
      return errors;
    },
    tipoSelectErrors() {
      const errors = [];
      if (!this.$v.tipoUsuarioValue.$dirty) return errors;
      !this.$v.tipoUsuarioValue.required &&
        errors.push("Tipo de usuario es obligatorio.");
      return errors;
    },
    rolSelectErrors() {
      // Boolean(Object.keys(v || {})[0])
      const errors = [];
      if (!this.$v.rolUsuarioValue.$dirty) return errors;
      !this.$v.rolUsuarioValue.required && errors.push("Rol es obligatorio.");
      return errors;
    },

    isDisabled() {
      if (this.tipeView != "modifica" || this.tipeView != "crear") {
        return false;
      } else {
        return this.usuario != null && this.usuario != "" ? true : false;
      }
    },
    isDisabledRol() {
      if (this.tipeView == "consulta" || this.tipeView == "modificar") {
        return true;
      }
    },
    disableonmodifica() {
      if (this.tipeView == "modifica") {
        return true;
      }
    },
    vistaconsulta() {
      if (this.tipeView == "consulta") {
        return true;
      }
    },
  },
  methods: {
    checkUsername() {
      if (
        this.username !== undefined &&
        this.username != null &&
        this.username != "" &&
        this.contratoId !== undefined &&
        this.contratoId != null &&
        this.contratoId != ""
      ) {
        axios
          .get("/user/" + this.username + "/contrato/" + this.contratoId)
          .then((response) => {
            if (!response.data.code || response.data.code === "undefined") {
              this.usuario = response.data;
              this.nombre = this.usuario.nombre;
              this.apellido = this.usuario.apellido;
              this.rut = this.usuario.rut;
              if (this.usuario.tipoUsuario == 'PROVEEDOR') {
                this.tipoUsuarioValue = 1;
              } else {
                this.tipoUsuarioValue = 0;
              }
              if (response.data.lstUsuContratoRol.length > 0) {
                this.hasContrato(response.data.lstUsuContratoRol);
              }
            }
          })
          .catch((error) => {
            //esta 'bien' que el usuario no este asociado al contrato, no mostrar error
            this.exist = false;
            // console.log(error);
            this.loading = false;
          });
      } else {
        // this.bttn = true;
      }
      // console.log(JSON.stringify(this.usuario));
      this.usernameErrors;
    },
    checkRUT() {
      if (
        this.rut !== undefined &&
        this.rut != null &&
        this.rut != "" &&
        this.contratoId !== undefined &&
        this.contratoId != null &&
        this.contratoId != ""
      ) {
        axios
          .get("/userRUT/" + this.rut + "/contrato/" + this.contratoId)
          .then((response) => {
            if (!response.data.code || response.data.code === "undefined") {
              this.usuario = response.data;
              this.nombre = this.usuario.nombre;
              this.apellido = this.usuario.apellido;
              this.username = this.usuario.username;
              if (response.data.lstUsuContratoRol.length > 0) {
                this.hasContrato(response.data.lstUsuContratoRol);
              }
            }
          })
          .catch((error) => {
            //esta 'bien' que el usuario no este asociado al contrato, no mostrar error
            this.exist = false;
            // console.log(error);
            this.loading = false;
          });
      } else {
        // this.bttn = true;
      }
      // console.log(JSON.stringify(this.usuario));
      this.usernameErrors;
    },

    async loadUsuarioData() {
      return await axios
        .get("/user/" + this.username + "/contrato/" + this.contratoId)
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    async loadRoles() {
      if (this.tipoUsuarioValue != null && this.tipoUsuarioValue >= 0) {
        let lista = await this.loadRoldata();
        let arreglo = [];
        lista.forEach(function (d) {
          arreglo.push({ nombre: d.nombre, id: d.id });
        });
        this.rolUsuarioSelect = arreglo;
      } else {
        this.rolUsuarioSelect = [];
      }
      this.rolUsuario = -1;
    },

    async loadRoldata() {
      return await axios
        .get("/roles/perfil/" + this.tipoUsuarioValue)
        .then((response) => {
          return response.data;
        })
        .catch((error) => {
          console.log("loadRoldata: error:" + error);
          return [];
        });
    },
    // setRolSelect(data) {
    //   let roles = [];
    //   data.forEach((r) => {
    //     if (this.tipoUsuarioValue == 1 && r.nombre == "ADMINISTRADOR") {
    //       return false;
    //     }
    //     if (this.tipoUsuarioValue === 0 && r.nombre === "JEFE DE PROYECTO") {
    //       return false;
    //     }

    //     roles.push({ id: r.id, nombre: r.nombre, codigo: r.codigoRol });
    //   });
    //   this.rolUsuarioSelect = roles;
    //   // console.log("st::this.rolUsuarioSelect:" + JSON.stringify(this.rolUsuarioSelect, null, 2));
    // },
    async loadContratoDato() {
      return await axios
        .get("/user/username/" + this.contratoId)
        .then((response) => {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getTipoRolContrato(datos) {
      var nombre = "";
      var tipo = "";
      let idContrato = this.contratoId;
      // console.log("st::datos:" + JSON.stringify(datos, null, 2));
      datos.forEach(function (objeto) {
        var claves = Object.keys(objeto);
        if (claves[0] == idContrato) {
          var valor = objeto[claves[0]];
          nombre = valor[0].nombre;
          tipo = valor[0].tipo;
          return;
        }
      });
      this.rolUsuarioValue = nombre;

      return;
    },

    async loadData() {
      this.usuario = await this.loadUsuarioData();
      console.log("st::this.usuario:" + JSON.stringify(this.usuario, null, 2));
      let rolesUsuario = this.getRol(this.usuario.lstUsuContratoRol);
      this.getTipoRolContrato(rolesUsuario);

      // Modificado para cargar roles correctamente
      if (this.usuario.tipo == "AGENCIA") {
        this.tipoUsuarioValue = 0;
      } else if (this.usuario.tipo == "PROVEEDOR") {
        this.tipoUsuarioValue = 1;
      }

      await this.loadRoles(); // Cargar roles antes de asignar valor

      if(this.usuario.perfil != null && this.usuario.perfil.id){
        this.rolUsuarioValue = this.usuario.perfil.id;
      }else{
        if (this.usuario.tipo == "AGENCIA") {
          this.rolUsuarioValue = 1; // lector agencia
      } else if (this.usuario.tipo == "PROVEEDOR") {
        this.rolUsuarioValue =16;//lector proveedor
      }else{
        this.rolUsuarioValue =17;
      }
        
      }
      

      this.nombre = this.usuario.nombre;
      this.rut = this.usuario.rut;
      this.id = this.usuario.id;
      this.apellido = this.usuario.apellido;


    },

    back() {
      setTimeout(() => {
        this.$router.go(-1);
      }, 1000);
    },

    save() {
      this.$v.$touch();
      let rutOk = this.validacionRut();
      if (!this.$v.$invalid && !this.existEnContrato && rutOk) {
        if (this.tipeView == "crear") {
          this.saveUser();
        } else {
          this.editUser();
        }
      }
    },
    validacionRut() {
      this.rutErrors = [];
      if (
        this.tipoUsuarioValue == this.tipoUsuarioProveedor &&
        this.rut == ""
      ) {
        this.rutErrors.push("RUT es obligatorio.");
        return false;
      }
      if (this.tipoUsuarioValue == this.tipoUsuarioProveedor && this.exist) {
        this.rutErrors.push("Usuario ya existe en el contrato");
        return false;
      }
      if (this.rut != null && this.rut.trim().length > 0) {
        this.rut = this.rut.toUpperCase();
        if (!this.validaRut(this.rut)) {
          this.rutErrors.push("RUT inválido.");
          return false;
        } else if (this.rut.length > 11) {
          this.rutErrors.push("El RUT debe tener como máximo 11 caracteres.");
          return false;
        }
      }
      return true;
    },
    validaRut(rut) {
      // Verificar si el RUT tiene el formato correcto
      if (!/^[0-9]+-[0-9kK]{1}$/.test(rut)) {
        return false;
      }

      let rutNumero = rut.split("-")[0];
      const rutDV = rut.split("-")[1];

      if (rutNumero.length < 7 || rutNumero.length > 9) {
        return false;
      }

      // Validar que el dígito verificador sea correcto
      let suma = 0;
      let multiplicador = 2;
      for (let i = rutNumero.length - 1; i >= 0; i--) {
        suma += parseInt(rutNumero.charAt(i)) * multiplicador;
        multiplicador = multiplicador === 7 ? 2 : multiplicador + 1;
      }
      const dvEsperado = 11 - (suma % 11);
      const dvCalculado =
        dvEsperado === 11
          ? "0"
          : dvEsperado === 10
            ? "K"
            : dvEsperado.toString();
      if (dvCalculado !== rutDV && !(dvCalculado === "0" && rutDV === "K")) {
        return false;
      }

      return true;
    },
    saveUser() {
      //  console.log("saveUser");
      if (!this.$v.$invalid && !this.exist) {
        this.loading = true;
        this.body = {
          username: this.username,
          rut: this.rut != null ? this.rut.trim() : "",
          nombre: this.nombre,
          apellido: this.apellido,
          tipo: this.tipoUsuarioValue,
          idRol: this.rolUsuarioValue,
          idContrato: this.$store.getters.contratoStored,
        };
        axios
          .post("/user/crear/usercontrato", this.body)
          .then((response) => {
            this.resp = response.data;
            this.loading = false;
            window.getApp.$emit("APP_SAVE");
            this.back();
          })
          .catch((error) => {
            if (error) {
              console.log(error.response.data);
              window.getApp.$emit(
                "ERROR_EXCEPTION",
                error.response.data.message
              );
              this.loading = false;
            }
          });
      }
      this.loading = false;
    },
    editUser() {
      this.loading = true;
      this.body = {
        username: this.username,
        rut: this.rut != null ? this.rut.trim() : "",
        nombre: this.nombre,
        apellido: this.apellido,
        tipo: this.tipoUsuarioValue,
        idRol: this.rolUsuarioValue,
        idContrato: this.$store.getters.contratoStored,
      };
      axios
        .put("/user/editar/usercontrato/" + this.id, this.body)
        .then((response) => {
          this.resp = response.data;
          this.loading = false;
          window.getApp.$emit("APP_UPDATE");
          this.back();
        })
        .catch((error) => {
          console.log(error);
          window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
          this.loading = false;
        });
    },
    //this is a map
    hasContrato(mapContrato) {
      //console.log("mapa values"+JSON.stringify(mapContrato[0]));
      for (const prop in mapContrato[0]) {
        if (mapContrato[0].hasOwnProperty(prop)) {
          this.exist = true;
          //console.log("prop : "+prop + " - object - " +JSON.stringify(mapContrato[0][prop]))
          //console.log(`${prop}: ${mapContrato[0][prop]}`)
        }
      }
    },
  },
};

var Fn = {
  // Valida el rut con su cadena completa "XXXXXXXX-X"
  validaRut: function (rutCompleto) {
    if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test(rutCompleto)) return false;
    var tmp = rutCompleto.split("-");
    var digv = tmp[1];
    var rut = tmp[0];
    if (digv == "K") digv = "k";
    return Fn.dv(rut) == digv;
  },
  dv: function (T) {
    var M = 0,
      S = 1;
    for (; T; T = Math.floor(T / 10)) S = (S + (T % 10) * (9 - (M++ % 6))) % 11;
    return S ? S - 1 : "k";
  },
};
</script>
